import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import '../../../spacing/types/index.esm.js';
import { EGDSSpacing } from '../../../spacing/spacing/index.esm.js';
import '../../../spacing/spacing-hr/index.esm.js';
import '../../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../../layout-flex/layout-flex-item/index.esm.js';
import { EGDSButtonSize } from '../../../button/button/index.esm.js';
import { EGDSPrimaryButton } from '../../../button/primary-button/index.esm.js';
import { EGDSTertiaryButton } from '../../../button/tertiary-button/index.esm.js';
import '../../../button/paging-button/index.esm.js';
import '../../../toolbar/toolbar/index.esm.js';
import { EGDSToolbar } from '../../../toolbar/egds-toolbar/index.esm.js';
import '../../../toolbar/toolbar-container/index.esm.js';
import '../../../toolbar/transparent-toolbar/index.esm.js';
import '../../../toolbar/toolbar-button/index.esm.js';
import styles from '../../../styles/uitk-egds-date-selector.css';
import { EGDSAlert } from '../../alert/index.esm.js';
import { classNames } from '../../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const ComposableCalendar = props => {
  const {
    children,
    ctaItems,
    dateSelectorPlayback,
    showPlayback,
    calendarWrapper,
    alertTemplateComponent,
    alertTemplateData,
    hideFooter,
    navType
  } = props;
  const {
    submitCta,
    clearDatesCta
  } = ctaItems;
  const CalendarWrapper = React.useMemo(() => calendarWrapper ? calendarWrapper.component : React.Fragment, [calendarWrapper]);
  const navTypeIsScrolling = navType === 'scrolling';
  const baseDateSelectorPlaybackWrapperClass = 'uitk-date-selector-playback-wrapper';
  const dateSelectorPlaybackWrapperCssClasses = {
    'uitk-date-selector-playback-wrapper-sticky': navTypeIsScrolling
  };
  const baseDateSelectorFooterClass = 'uitk-date-selector-footer';
  const dateSelectorFooterCssClasses = {
    'uitk-date-selector-footer-sticky': navTypeIsScrolling
  };
  return jsxs(Fragment, {
    children: [jsxs(CalendarWrapper, {
      ...calendarWrapper?.props,
      children: [showPlayback && jsx("div", {
        "data-testid": "date-selector-playback-wrapper",
        className: getClassNameList(baseDateSelectorPlaybackWrapperClass, dateSelectorPlaybackWrapperCssClasses),
        children: jsx(EGDSToolbar, {
          children: dateSelectorPlayback
        })
      }), jsx("div", {
        children: children
      })]
    }), alertTemplateComponent && !navTypeIsScrolling && jsx(EGDSAlert, {
      alertTemplateComponent: alertTemplateComponent,
      alertTemplateData: alertTemplateData
    }), !hideFooter && jsx(EGDSSpacing, {
      padding: {
        inline: 'two',
        block: 'three'
      },
      children: jsxs("footer", {
        className: getClassNameList(baseDateSelectorFooterClass, dateSelectorFooterCssClasses),
        "data-testid": "date-selector-footer",
        children: [alertTemplateComponent && navTypeIsScrolling && jsx(EGDSAlert, {
          alertTemplateComponent: alertTemplateComponent,
          alertTemplateData: alertTemplateData
        }), jsxs(EGDSLayoutFlex, {
          space: "three",
          justifyContent: navTypeIsScrolling ? 'center' : 'end',
          children: [clearDatesCta.handler && !navTypeIsScrolling && jsx(EGDSLayoutFlexItem, {
            children: jsx(EGDSTertiaryButton, {
              onClick: clearDatesCta.handler,
              "aria-disabled": clearDatesCta.disabled,
              tabIndex: clearDatesCta.disabled ? -1 : 0,
              children: clearDatesCta.label
            })
          }), submitCta.handler && jsx(EGDSLayoutFlexItem, {
            children: jsx(EGDSPrimaryButton, {
              "data-stid": "apply-date-selector",
              disabled: submitCta.disabled,
              onClick: submitCta.handler,
              isFullWidth: navTypeIsScrolling,
              size: navTypeIsScrolling ? EGDSButtonSize.LARGE : EGDSButtonSize.MEDIUM,
              children: submitCta.label
            })
          })]
        })]
      })
    })]
  });
};
export { ComposableCalendar };